import { useObserver } from "mobx-react";
import { useStores } from "../../../store";
import { AiOutlineDelete } from "react-icons/ai";

export default function Description(props) {
  const { RecuiterStore } = useStores();
  // useEffect(() => {
  //   if (!props.score) {
  //     RecuiterStore.setJobDescription(null);
  //   }
  //   // RecuiterStore.setGeneratedJD();
  // }, []);
  return useObserver(() => {
    return (
      <div>
        <span className="flex flex-col gap-2 p-3 border-[0.5px] border-opacity-50  border-black rounded-lg">
          <textarea
            type="text"
            name="desc"
            readOnly={props.score}
            className=" text-[#A7A7A7]  focus:outline-none min-h-[6rem]  rounded-lg p-1"
            id="desc"
            value={
              props.score
                ? RecuiterStore.resumeScore?.data?.resumes[0]?.jdDescription ||
                  RecuiterStore.resumeScore?.data?.resumes[0]?.jobDescription
                : RecuiterStore.generatedJD
            }
            onChange={(e) => {
              RecuiterStore.setGeneratedJD(e.target.value);
            }}
            placeholder="Enter Your Job description"
            // {...(!props.score ? { defaultValue: RecuiterStore.jobDescription } : {})}
            // defaultValue="Lorem ipsum dolor sit amet consectetur. Malesuada nunc leo tortor placerat. Tellus mollis nam fringilla urna posuere. Vel leo suspendisse non nisi. Ut massa tristique in sagittis dolor vestibulum ornare. Mattis sodales amet in malesuada etiam nec neque nam. Purus viverra adipiscing porttitor elit sagittis pellentesque. Eget scelerisque consectetur egestas id euismod ipsum vitae duis viverra. Pharetra senectus enim neque sed libero. Vitae venenatis dignissim non nibh egestas magna id nulla ipsum."
          />
          {!props.score && (
            <span className="w-full flex flex-row justify-end items-center gap-4 ">
              <AiOutlineDelete
                className="cursor-pointer"
                onClick={() => {
                  RecuiterStore.setGeneratedJD("");
                }}
              />
              {/* <AiOutlineCloudUpload /> */}
            </span>
          )}
        </span>
      </div>
    );
  });
}
